import { Instagram, Phone, Mail, ArrowUp } from "lucide-react";
import { LANDING } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={LANDING.footer}
      className="relative bg-[#0E0E0E] text-white"
    >
      <div className="h-1.5 bg-[#FFE512]" />

      <div className="max-w-[1280px] mx-auto px-5 md:px-8 lg:px-12 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#FFE512] flex items-center justify-center font-display text-[#0E0E0E] text-base rounded-sm">JT</div>
              <div className="leading-tight">
                <div className="font-display text-xl">James Townsend</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#FFE512]">Licensee Salesperson</div>
              </div>
            </div>
            <p className="mt-4 max-w-md text-[14.5px] text-white/60 leading-relaxed">
              Mount Maunganui &amp; Papamoa real estate, delivered with energy,
              passion, and straight-up advice.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#FFE512] mb-4">Explore</div>
            <ul className="space-y-2.5 text-[14px] text-white/80">
              <li><a href="#about" className="hover:text-[#FFE512] transition-colors">About James</a></li>
              <li><a href="#contact" className="hover:text-[#FFE512] transition-colors">Contact</a></li>
              <li><a href="#contact" className="hover:text-[#FFE512] transition-colors">Sales appraisal</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#FFE512] mb-4">Contact</div>
            <ul className="space-y-2.5 text-[14px] text-white/80">
              <li>
                <a data-testid={LANDING.footerPhone} href="tel:+64272141475" className="inline-flex items-center gap-2 hover:text-[#FFE512]">
                  <Phone className="w-3.5 h-3.5" /> +64 27 214 1475
                </a>
              </li>
              <li>
                <a data-testid={LANDING.footerEmail} href="mailto:james@jamestownsendrealestate.co.nz" className="inline-flex items-start gap-2 hover:text-[#FFE512]">
                  <Mail className="w-3.5 h-3.5 mt-1 shrink-0" />
                  <span className="break-all text-[13.5px]">james@jamestownsendrealestate.co.nz</span>
                </a>
              </li>
              <li>
                <a data-testid={LANDING.footerInstagram} href="https://www.instagram.com/jamestownsend_raywhite/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[#FFE512]">
                  <Instagram className="w-3.5 h-3.5" /> Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] text-white/45">
          <span>© {new Date().getFullYear()} James Townsend. All rights reserved.</span>
          <span className="uppercase tracking-[0.18em]">Licensee Salesperson · REAA 2008</span>
          <a href="#top" className="inline-flex items-center gap-2 hover:text-[#FFE512]">
            Back to top <ArrowUp className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </footer>
  );
}
